"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _default = exports.default = {
  components: {},
  computed: {},
  watch: {},
  data: function data() {
    return {
      // 商品类型(原设备类型）
      product_type: [
      // { key: 1, display_name: '有设备(两个盘)' },
      {
        key: 'all',
        display_name: '全部'
      }, {
        key: 2,
        display_name: '设备'
      },
      //有设备(四个盘)
      {
        key: 0,
        display_name: '调理包'
      },
      //无设备
      {
        key: 3,
        display_name: '云平台专用'
      }],
      // 产品包类型
      goods_pkg_type: [{
        key: 1,
        display_name: '到家产品包'
      }, {
        key: 2,
        display_name: '到店产品包'
      }, {
        key: 3,
        display_name: '机构产品包'
      }
      // { key: 4, display_name: '事业合伙人产品包' }
      ],
      // 合伙人产品包类型
      goods_shop_pkg_type: [{
        key: 1,
        display_name: '公共区域设备购买，不限制处方'
      }, {
        key: 2,
        display_name: '穴位数购买(不限制处方)'
      }, {
        key: 3,
        display_name: 'B端到家产品包(不含设备)购买'
      }, {
        key: 4,
        display_name: 'B端到家产品包(含设备)购买'
      }],
      // 是否已打开产品包
      yesOrNoOption: [{
        key: false,
        display_name: '否'
      }, {
        key: true,
        display_name: '是'
      }],
      // C端商城订单类型
      c_order_pkg_type: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 1,
        display_name: '到家'
      }, {
        key: 2,
        display_name: '到店'
      }, {
        key: 3,
        display_name: '机构'
      }
      // { key: 4, display_name: '事业合伙人产品包' }
      ],
      // 调理码使用状态
      voucher_usage: [{
        key: 0,
        display_name: '未使用'
      }, {
        key: 1,
        display_name: '已使用'
      }],
      // 合作伙伴类型
      group_type: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 2,
        display_name: 'B端合作伙伴'
      }, {
        key: 1,
        display_name: '大客户'
      }],
      // B端合作伙伴Level
      group_level: [{
        key: "level_1",
        display_name: 'Level 1'
      }, {
        key: "level_2",
        display_name: 'Level 2'
      }, {
        key: "level_3",
        display_name: 'Level 3'
      }, {
        key: "level_4",
        display_name: 'Level 4'
      }, {
        key: "level_5",
        display_name: 'Level 5'
      }],
      // 退款退貨單類型
      return_type: [{
        key: 1,
        display_name: '退货'
      }, {
        key: 2,
        display_name: '退款'
      }]
    };
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    // 退款退貨單類型
    getReturnType: function getReturnType(val) {
      var result = this.return_type.filter(function (item) {
        return item.key * 1 === val * 1;
      });
      return result.length ? result[0].display_name : '-';
    },
    // 设备类型
    getProductType: function getProductType(val) {
      var result = this.product_type.filter(function (item) {
        return item.key * 1 === val * 1;
      });
      return result.length ? result[0].display_name : '-';
    },
    // 产品包类型
    getGoodsPkgType: function getGoodsPkgType(val) {
      var result = this.goods_pkg_type.filter(function (item) {
        return item.key * 1 === val * 1;
      });
      return result.length ? result[0].display_name : '-';
    },
    // 是否已打开产品包
    getPackageOpened: function getPackageOpened(val) {
      var result = this.yesOrNoOption.filter(function (item) {
        return item.key + '' === val + '';
      });
      return result.length ? result[0].display_name : '-';
    },
    // 是否已使用调理码
    getVoucherUsed: function getVoucherUsed(val) {
      var result = this.voucher_usage.filter(function (item) {
        return item.key * 1 === val * 1;
      });
      return result.length ? result[0].display_name : '-';
    },
    // 取得合作伙伴类型名
    getGroupTypeName: function getGroupTypeName(val) {
      var result = this.group_type.filter(function (item) {
        return item.key * 1 === val * 1;
      });
      return result.length ? result[0].display_name : '-';
    }
  }
};